import axios, { AxiosRequestHeaders } from "axios";
import { FormEventHandler, useCallback, useEffect, useState } from "react";
import { ILoginData2 } from "../../../models";
import { HOSTNAME } from "../api-utils";
import { ApiTesterComponent, IApiFetcher } from "../ApiTesterApp";
import { usersFavoritesGetGet } from "./UsersFavoritesGet";

export const usersFavoritesDelPost: IApiFetcher = async ({
  utoken,
  data,
  omitUserAgent = false,
}: {
  utoken: string;
  data: any;
  omitUserAgent?: boolean;
}) => {
  const headers: AxiosRequestHeaders = {};
  if (!omitUserAgent) {
    headers["User-Agent"] = "I:2.5.0(256)";
  }
  headers["utoken"] = utoken;

  const parsedData = JSON.parse(data);

  const response = await axios.post<any>(
    `${HOSTNAME}${usersFavoritesDelPost.url}`,
    { items: [parsedData] },
    {
      headers,
    }
  );
  return response.data;
};
usersFavoritesDelPost.url = "/wp-json/wp/v3/users/favorites/del";
usersFavoritesDelPost.method = 'POST';

const UsersFavoritesDel: ApiTesterComponent = ({ loginData }: { loginData: ILoginData2 | null }) => {
  const [toDelete, setToDelete] = useState<string>("");
  const [data, setData] = useState<string>("");
  const [loading, setIsLoading] = useState<boolean>(true);

  const libraryGetBinded = useCallback(() => loginData ? usersFavoritesGetGet({utoken: loginData.token, omitUserAgent: true}).then(data => {
    setData(JSON.stringify(data, null, 2));
    setIsLoading(false);
  }) : undefined, [loginData]);

  useEffect(() => {
    libraryGetBinded();
  }, [libraryGetBinded])

  const onAddToPlaylist: FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();

    if (loginData?.token) {
      setIsLoading(true);
       UsersFavoritesDel.fetcher({
        utoken: loginData.token,
        data: toDelete,
        omitUserAgent: true,
      }).then(() => {
        libraryGetBinded();
      });
    }
  };

  return (
    <div>
      <h3>UsersFavoritesDel</h3>
      <form onSubmit={onAddToPlaylist}>
        <textarea
          value={toDelete}
          required
          onChange={(event) => setToDelete(event.target.value)}
        />
        <input type="submit" value="Add" />
      </form>
      <pre>{loading ? "Loading..." : data}</pre>
    </div>
  );
};

UsersFavoritesDel.fetcher = usersFavoritesDelPost;

export default UsersFavoritesDel;
